import React from "react";
import {observer} from "mobx-react-lite";
import appStore from "../../storage/AppStore";
import {Link} from "react-router-dom";

const CompaniesMenu = () => {
    if (appStore.user.companies.length === 0) return null
    return (
        <li className="nav-item dropdown position-static py-lg-2 me-lg-n1 me-xl-0">
            <a className="nav-link dropdown-toggle active" aria-current="page" href="#" role="button"
               data-bs-toggle="dropdown" data-bs-trigger="hover" aria-expanded="false">{appStore.tr.my_clubs}</a>

            <div className="dropdown-menu rounded-4 p-4"
                 style={{"--cz-dropdown-spacer": ".875rem"}}>
                <div className="d-flex flex-column flex-lg-row gap-4">
                    {appStore.user.companies.map((club, index) => (
                        <div key={index} style={{"minWidth": "190px"}}>
                            <div className="h6 mb-2"><Link to={`/club/${club.company.id}`}>{club.company.name}</Link>
                            </div>
                            {/*<ul className="nav flex-column gap-2 mt-0">*/}
                            {/*    <li className="d-flex w-100 pt-1">*/}
                            {/*        <Link*/}
                            {/*            className="nav-link animate-underline animate-target d-inline fw-normal text-truncate p-0"*/}
                            {/*            to="/admin/new_company">Жаңы компания</Link>*/}
                            {/*    </li>*/}
                            {/*</ul>*/}
                        </div>
                    ))}
                </div>
            </div>
        </li>
    );
}

export default observer(CompaniesMenu)